import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Watches from './components/Watches';
import RepairEstimator from './components/RepairEstimator';
import Contact from './components/Contact';
import Footer from './components/Footer';
import RepairEstimatePage from './pages/RepairEstimatePage';
import NotFound from './pages/NotFound';
import SEO from './components/SEO';

function HomePage() {
  return (
    <>
      <SEO />
      <Hero />
      <About />
      <Services />
      <Watches />
      <RepairEstimator />
      <Contact />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/repair-estimate" element={<RepairEstimatePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
